import React, { Component } from 'react';

export default class Button extends Component {

    render() {

        let {className, onClick, children, disabled} = this.props;

        if(disabled){
            return (
                <button onClick={onClick} disabled={'disabled'}
                        className={`btn btn-shell-empty z-depth-0 ${className} disabled`}>
                    {children}
                </button>
            );
        }

        return (
            <button onClick={onClick}
                className={`btn btn-shell-empty z-depth-0 ${className}`}>
                {children}
            </button>
        );
    }
}

Button.defaultProps = {
    onClick: () => {},
    className: '',
    color: '',
    disabled: false
};


// WEBPACK FOOTER //
// ./src/components/Button/Button.js